module.exports = __webpack_public_path__ + "img/TZ.70dd4d9b.svg";